import React, { useState, useEffect } from 'react';
import axios from '../utils/axiosInstance';
import '../assets/css/adminpanel.css';

const GenerateRandomNumbers = () => {
    const [topNumbers, setTopNumbers] = useState([]);
    const [sideNumbers, setSideNumbers] = useState([]);
    const [published, setPublished] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const defaultLabels = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];

    useEffect(() => {
        const fetchPublishedNumbers = async () => {
            try {
                const response = await axios.get('/board/grid-labels');
                if (response.data.published) {
                    setTopNumbers(response.data.topLabels);
                    setSideNumbers(response.data.sideLabels);
                    setPublished(true);
                } else {
                    setTopNumbers(defaultLabels);
                    setSideNumbers(defaultLabels);
                }
            } catch (err) {
                console.error('Error fetching published numbers:', err);
                setError('Failed to fetch existing numbers. Defaulting to placeholders.');
                setTopNumbers(defaultLabels);
                setSideNumbers(defaultLabels);
            }
        };

        fetchPublishedNumbers();
    }, []);

    const generateNumbers = () => {
        const generateUniqueRandomNumbers = () => {
            const numbers = Array.from({ length: 10 }, (_, i) => i);
            return numbers.sort(() => Math.random() - 0.5);
        };

        setTopNumbers(generateUniqueRandomNumbers());
        setSideNumbers(generateUniqueRandomNumbers());
        setPublished(false);
        setError('');
        setSuccessMessage('');
    };

    const publishNumbers = async () => {
        if (topNumbers.length === 0 || sideNumbers.length === 0) {
            setError('Please generate numbers before publishing.');
            return;
        }
        setError('');
        setLoading(true);
        setSuccessMessage('');
        try {
            await axios.post('/admin/publish-grid-labels', {
                topLabels: topNumbers,
                sideLabels: sideNumbers,
            });
            setPublished(true);
            setSuccessMessage('Labels have been successfully published to the main site!');
        } catch (err) {
            console.error('Error publishing numbers:', err);
            setError(err.response?.data?.message || 'Failed to publish numbers. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const resetLabels = async () => {
        setError('');
        setLoading(true);
        setSuccessMessage('');
        try {
            await axios.post('/admin/reset-grid-labels');
            setTopNumbers(defaultLabels);
            setSideNumbers(defaultLabels);
            setPublished(false);
            setSuccessMessage('Labels have been reset to placeholders.');
        } catch (err) {
            console.error('Error resetting labels:', err);
            setError('Failed to reset labels. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-panel container">
            <header className="card admin-header">
                <h2>Generate Random Numbers</h2>
                <p>
                    Manage the top and side labels of the grid by generating, publishing, or resetting random numbers.
                </p>
            </header>
            <div className="card">
                <div className="button-container">
                    <button
                        className="button button-primary"
                        onClick={generateNumbers}
                        disabled={loading}
                    >
                        Generate Random Numbers
                    </button>
                    <button
                        className="button button-primary"
                        onClick={publishNumbers}
                        disabled={loading || topNumbers.length === 0 || published}
                    >
                        Publish
                    </button>
                    <button
                        className="button button-secondary"
                        onClick={resetLabels}
                        disabled={loading}
                    >
                        Reset Labels
                    </button>
                </div>
                {error && <p className="error-message">{error}</p>}
                {successMessage && <p className="success-message">{successMessage}</p>}
                <div className="numbers-display">
                    <h3>Generated Numbers</h3>
                    <div>
                        <strong>Top Labels:</strong> {topNumbers.join(', ') || 'None'}
                    </div>
                    <div>
                        <strong>Side Labels:</strong> {sideNumbers.join(', ') || 'None'}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GenerateRandomNumbers;